import React from 'react';
import useAuth from '../hooks/utils/useAuth';

interface CrisisResourceSectionTitleProps {
  emergency?: boolean;
  imageUrl?: string;
}

const HeartHandIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5.5C12 4.12 13.12 3 14.5 3C15.88 3 17 4.12 17 5.5C17 6.88 15.88 8 14.5 8H12V5.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.5C12 4.12 10.88 3 9.5 3C8.12 3 7 4.12 7 5.5C7 6.88 8.12 8 9.5 8H12V5.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14H6.39C6.77 14 7.15 14.11 7.47 14.32L10.53 16.18C10.85 16.39 11.23 16.5 11.61 16.5H14C15.1 16.5 16 15.6 16 14.5C16 13.4 15.1 12.5 14 12.5H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 12.5L19.53 11.32C20.3 10.73 21.37 10.81 22.06 11.5V11.5C22.75 12.19 22.83 13.26 22.24 14.03L18.69 18.65C18.24 19.23 17.57 19.6 16.83 19.68L13.77 20C13.05 20.08 12.33 19.87 11.76 19.43L10.24 18.29C9.55 17.76 9.1 17 9 16.15L8.66 13.39C8.52 12.24 9.31 11.21 10.46 11.06C11.28 10.96 12.06 11.39 12.42 12.11L12.5 12.28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrisisResourceSectionTitle: React.FC<CrisisResourceSectionTitleProps> = ({
  emergency = false,
  imageUrl,
}) => {
  const { user } = useAuth();
  const clientLogoUrl = user?.caller_role.active_subscription?.package?.client?.logo_file_url;
  const displayImageUrl = clientLogoUrl || imageUrl;

  return (
    <div className="mb-4 w-full md:mb-0">
      <div className="border-input-border-gray border-t md:border-t-0 [@media(max-height:700px)]:border-t" />
      <div className="flex items-center gap-3 py-4">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full ${
            emergency ? 'bg-red-100' : 'bg-blue-100'
          }`}
        >
          {displayImageUrl ? (
            <img src={displayImageUrl} alt="Client logo" className="h-full w-full object-cover" />
          ) : (
            <HeartHandIcon className={`h-5 w-5 ${emergency ? 'text-red-600' : 'text-blue-600'}`} />
          )}
        </div>
        <div>
          <p className="font-albert-sans text-label-gray text-lg font-semibold leading-6">We're here to help</p>
          <p className="font-albert-sans text-placeholder-gray text-sm">Support from your organization</p>
        </div>
      </div>
      <div className="border-input-border-gray border-t md:border-t-0 [@media(max-height:700px)]:border-t" />
    </div>
  );
};
